'use client';
import { ISessionUser } from '@negotium/models';
import { useCookies } from 'next-client-cookies';

const useSessionClient = (): ISessionUser | null => {
	const cookies = useCookies();
	const token = cookies.get(process.env['NEXT_PUBLIC_AUTH_COOKIE_NAME'] ?? '');

	const sessionCookie = cookies.get(
		process.env['NEXT_PUBLIC_AUTH_COOKIE_PERMISSIONS_NAME'] ?? ''
	);
	if (token) {
		try {
			let dataSession = null;
			if (sessionCookie) {
				dataSession = JSON.parse(sessionCookie);
			}
			if (
				!dataSession.name ||
				!dataSession.lastName ||
				!dataSession.image.url
			) {
				return null;
			}
			const session: ISessionUser = {
				name: dataSession.name,
				lastName: dataSession.lastName,
				image: dataSession.image,
				permissions: dataSession.permissions,

				token,
			};

			return session;
		} catch (error) {
			return null;
		}
	}
	return null;
};

export default useSessionClient;
